export enum Category {
    HATS = "hats",
    SHOES = "shoes",
    WATCHES = "watches",
    EYEWEAR = "eyewear",
    TRENDING = "trending",
}